(() => {
  const root = document.querySelector('[data-pal-about-story]');
  if (!root) return;

  const founderContacts = {
    Brijesh: {
      whatsapp: 'whatsapp://send?phone=918160584266&text=Hi%20Brijesh%2C%20I%E2%80%99m%20reaching%20out%20through%20PickALeaf%20and%20would%20love%20to%20connect%20with%20you.',
      instagram: 'https://www.instagram.com/brijesh_sanghani__?igsi=MTQweHp3enhwNHdhNg%3D%3D&utm_source=qr'
    },
    Nima: {
      whatsapp: 'whatsapp://send?phone=17057709706&text=Hi%20Nima%2C%20I%E2%80%99m%20reaching%20out%20through%20PickALeaf%20and%20would%20love%20to%20connect%20with%20you.',
      instagram: 'https://www.instagram.com/nima_brijesh?igsi=MWthN3Y0Y3k0MWU0OQ=='
    }
  };

  /*
   * About Us visual overrides.
   * 60% transparent means the card surface itself is 40% opaque.
   * Keep text/images fully opaque and avoid backdrop-filter compositing flicker.
   */
  if (!document.getElementById('pal-about-v6-overrides')) {
    const style = document.createElement('style');
    style.id = 'pal-about-v6-overrides';
    style.textContent = `
      .pal-about-story{
        background:#070805!important;
      }

      .pal-about-story__backdrop{
        background-color:#070805!important;
        background-image:
          linear-gradient(180deg,rgba(3,5,3,.10) 0%,rgba(3,5,3,.035) 44%,rgba(2,4,2,.14) 100%),
          url('https://cdn.shopify.com/s/files/1/0573/6660/9992/files/pickaleaf-about-bg-desktop-v3.webp?v=1788117975&width=2200')!important;
        background-size:cover,cover!important;
        background-position:center center,center center!important;
        background-repeat:no-repeat,no-repeat!important;
      }

      .pal-about-story__backdrop::before{
        content:''!important;
        position:absolute!important;
        inset:0!important;
        background:
          radial-gradient(circle at 50% 23%,rgba(238,199,108,.105),transparent 39%),
          linear-gradient(90deg,rgba(1,3,2,.17) 0%,transparent 18%,transparent 82%,rgba(1,3,2,.17) 100%)!important;
        opacity:1!important;
        pointer-events:none!important;
      }

      .pal-about-story__backdrop::after{
        content:''!important;
        position:absolute!important;
        inset:0!important;
        background:linear-gradient(180deg,rgba(0,0,0,.065),rgba(0,0,0,.015) 34%,rgba(0,0,0,.10))!important;
        opacity:1!important;
        pointer-events:none!important;
      }

      .pal-about-story .pal-glass{
        background:rgba(5,9,6,.40)!important;
        background-image:none!important;
        border:1px solid rgba(242,211,137,.48)!important;
        -webkit-backdrop-filter:none!important;
        backdrop-filter:none!important;
        box-shadow:
          inset 0 1px 0 rgba(255,249,226,.22),
          inset 1px 0 0 rgba(255,255,255,.035),
          inset -1px 0 0 rgba(229,184,82,.050),
          inset 0 -1px 0 rgba(185,132,37,.070),
          0 16px 38px rgba(0,0,0,.16),
          0 0 20px rgba(222,173,67,.028)!important;
      }

      .pal-about-story .pal-glass::after{
        background:none!important;
        opacity:0!important;
      }
      .pal-about-story .pal-glass::before{
        opacity:.48!important;
      }

      .pal-about-story__copy,
      .pal-about-story__media,
      .pal-about-story__intro,
      .pal-about-story__manifesto,
      .pal-about-story__proof,
      .pal-about-story__closing{
        background:rgba(5,9,6,.40)!important;
        background-image:none!important;
        -webkit-backdrop-filter:none!important;
        backdrop-filter:none!important;
      }

      .pal-about-story__proof-item{
        background:rgba(5,9,6,.40)!important;
        background-image:none!important;
        border-color:rgba(232,193,97,.28)!important;
        -webkit-backdrop-filter:none!important;
        backdrop-filter:none!important;
      }

      .pal-about-story__button,
      .pal-about-story__button:hover{
        background:rgba(5,9,6,.40)!important;
        background-image:none!important;
        -webkit-backdrop-filter:none!important;
        backdrop-filter:none!important;
      }

      .pal-about-story .pal-glass > *,
      .pal-about-story__proof-item > *,
      .pal-about-story__button > *{
        opacity:1!important;
      }

      /* Founder refinements */
      .pal-about-story__founders-couple{
        display:flex!important;
        align-items:center!important;
        justify-content:center!important;
        gap:9px!important;
        width:max-content!important;
        max-width:100%!important;
        margin:13px auto 0!important;
        color:rgba(244,218,139,.94)!important;
        font-family:"Cormorant Garamond",Georgia,serif!important;
        font-size:18px!important;
        font-style:italic!important;
        font-weight:400!important;
        line-height:1.2!important;
        letter-spacing:.01em!important;
      }
      .pal-about-story__founders-couple::before,
      .pal-about-story__founders-couple::after{
        content:"";
        display:block;
        width:24px;
        height:1px;
        background:rgba(232,193,97,.40);
      }

      .pal-about-story__founder-bio{
        max-width:430px!important;
        margin:14px auto 0!important;
        color:rgba(245,239,227,.70)!important;
        font-size:12.5px!important;
        line-height:1.66!important;
      }

      .pal-about-story__founder-connect{
        width:min(100%,430px);
        margin:22px auto 0;
        padding-top:18px;
        border-top:1px solid rgba(232,193,97,.20);
      }
      .pal-about-story__founder-connect-label{
        display:block;
        margin:0 0 10px;
        color:rgba(245,239,227,.48);
        font-size:7.5px;
        font-weight:700;
        letter-spacing:.20em;
        text-transform:uppercase;
      }
      .pal-about-story__founder-contact-actions{
        display:grid;
        grid-template-columns:repeat(2,minmax(0,1fr));
        gap:8px;
      }
      .pal-about-story__founder-contact{
        min-height:44px;
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        padding:0 14px;
        border:1px solid rgba(232,199,109,.34);
        border-radius:12px;
        background:rgba(5,9,6,.22);
        color:rgba(245,239,227,.80);
        font-size:8.5px;
        font-weight:650;
        letter-spacing:.13em;
        text-transform:uppercase;
        text-decoration:none;
        transition:border-color .22s ease,background .22s ease,transform .22s ease;
      }
      .pal-about-story__founder-contact-icon{
        flex:0 0 auto;
        width:18px;
        height:18px;
        display:grid;
        place-items:center;
        color:#efd47f;
        line-height:0;
      }
      .pal-about-story__founder-contact-icon svg{
        display:block;
        width:100%;
        height:100%;
        overflow:visible;
      }
      .pal-about-story__founder-contact[aria-disabled="true"]{
        cursor:default;
      }

      @media (min-width:900px){
        .pal-about-story__founder-photo{
          width:40%!important;
          max-width:235px!important;
          margin:18px auto 0!important;
          aspect-ratio:1/1!important;
        }
      }

      @media (hover:hover) and (min-width:900px){
        a.pal-about-story__founder-contact:hover{
          transform:translateY(-2px);
          border-color:rgba(242,214,127,.68);
          background:rgba(12,26,17,.34);
        }
      }

      @media (max-width:899px){
        .pal-about-story__backdrop{
          background-image:
            linear-gradient(180deg,rgba(3,5,3,.08) 0%,rgba(3,5,3,.025) 43%,rgba(2,4,2,.12) 100%),
            url('https://cdn.shopify.com/s/files/1/0573/6660/9992/files/pickaleaf-about-bg-mobile-v3.webp?v=1788117984&width=1400')!important;
          background-size:cover,cover!important;
          background-position:center center,center center!important;
          background-repeat:no-repeat,no-repeat!important;
        }

        .pal-about-story .pal-glass,
        .pal-about-story__copy,
        .pal-about-story__media,
        .pal-about-story__intro,
        .pal-about-story__manifesto,
        .pal-about-story__proof,
        .pal-about-story__closing,
        .pal-about-story__proof-item,
        .pal-about-story__button{
          background:rgba(5,9,6,.40)!important;
          background-image:none!important;
          -webkit-backdrop-filter:none!important;
          backdrop-filter:none!important;
        }

        .pal-about-story__founder-photo{
          width:55%!important;
          max-width:210px!important;
          margin:14px auto 0!important;
          aspect-ratio:1/1!important;
        }
        .pal-about-story__founders-couple{
          margin-top:11px!important;
          font-size:16px!important;
        }
        .pal-about-story__founder-bio{
          font-size:12.4px!important;
          line-height:1.62!important;
        }
        .pal-about-story__founder-connect{
          margin-top:18px;
          padding-top:15px;
        }
        .pal-about-story__founder-contact{
          min-height:42px;
          padding:0 12px;
          font-size:8px;
        }
        .pal-about-story__founder-contact-icon{
          width:17px;
          height:17px;
        }
      }

      @media (max-width:380px){
        .pal-about-story__founder-contact-actions{
          grid-template-columns:1fr;
        }
      }
    `;
    document.head.appendChild(style);
  }

  /* Premium couple note, kept outside the reveal system. */
  const foundersHead = root.querySelector('.pal-about-story__founders-head');
  if (foundersHead && !foundersHead.querySelector('.pal-about-story__founders-couple')) {
    const title = foundersHead.querySelector('h2');
    const couple = document.createElement('p');
    couple.className = 'pal-about-story__founders-couple';
    couple.textContent = 'A couple behind the brand.';
    if (title) title.insertAdjacentElement('afterend', couple);
  }

  /* Founder contact UI with direct WhatsApp app deep links. */
  const founderCards = [...root.querySelectorAll('.pal-about-story__founder-card')];
  founderCards.forEach((card) => {
    const info = card.querySelector('.pal-about-story__founder-info');
    if (!info || info.querySelector('[data-pal-founder-connect]')) return;

    const heading = info.querySelector('h3');
    const name = heading ? heading.textContent.trim() : 'Founder';
    const bio = heading ? heading.nextElementSibling : null;
    if (bio && bio.tagName === 'P') bio.classList.add('pal-about-story__founder-bio');

    const contactData = founderContacts[name] || { whatsapp: '', instagram: '' };
    const connect = document.createElement('div');
    connect.className = 'pal-about-story__founder-connect';
    connect.dataset.palFounderConnect = 'true';

    const label = document.createElement('span');
    label.className = 'pal-about-story__founder-connect-label';
    label.textContent = `CONNECT WITH ${name.toUpperCase()}`;

    const actions = document.createElement('div');
    actions.className = 'pal-about-story__founder-contact-actions';

    [
      { key: 'whatsapp', label: 'WhatsApp' },
      { key: 'instagram', label: 'Instagram' }
    ].forEach((item) => {
      const href = contactData[item.key] || '';
      const control = document.createElement(href ? 'a' : 'span');
      control.className = 'pal-about-story__founder-contact';
      control.dataset.channel = item.key;

      if (href) {
        control.href = href;
        if (item.key === 'instagram') {
          control.target = '_blank';
          control.rel = 'noopener noreferrer';
        }
      } else {
        control.setAttribute('aria-disabled', 'true');
      }

      const text = document.createElement('span');
      text.textContent = item.label;

      const icon = document.createElement('span');
      icon.className = 'pal-about-story__founder-contact-icon';
      icon.setAttribute('aria-hidden', 'true');

      if (item.key === 'instagram') {
        icon.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><rect x="3.25" y="3.25" width="17.5" height="17.5" rx="5.25" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="4.1" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="17.4" cy="6.65" r="1.15" fill="currentColor"/></svg>';
      } else {
        icon.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><path d="M20.25 11.7a8.18 8.18 0 0 1-12.08 7.18L4.1 20l1.12-3.93A8.18 8.18 0 1 1 20.25 11.7Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.02 8.32c.2-.49.49-.53.79-.53h.39c.22 0 .4.1.51.38l.78 1.91c.11.27.08.48-.1.69l-.57.68c-.17.2-.2.38-.08.61.5.97 1.29 1.78 2.28 2.28.23.12.42.09.61-.1l.72-.82c.2-.23.42-.29.69-.18l1.87.87c.29.13.41.31.41.54 0 .4-.22 1.18-.78 1.72-.61.59-1.5.82-2.47.63-1.51-.29-3.32-1.27-4.81-2.77-1.45-1.46-2.37-3.24-2.62-4.55-.16-.83.02-1.43.39-1.92Z" fill="currentColor"/></svg>';
      }

      control.append(text, icon);
      actions.appendChild(control);
    });

    connect.append(label, actions);
    info.appendChild(connect);
  });

  if (root.dataset.palStoryReady === 'true') return;
  root.dataset.palStoryReady = 'true';

  const items = [...root.querySelectorAll('.pal-about-story__reveal')];
  if (!items.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  root.classList.add('js-ready');

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      obs.unobserve(entry.target);
    });
  }, {
    threshold: 0.08,
    rootMargin: '18% 0px 18% 0px'
  });

  items.forEach((item) => observer.observe(item));
})();
